/* eslint-disable camelcase */
import Axios from 'axios'
import globalConfig from '../config'

export const reservationService = {
  createPaymentIntent: async (precio_boleto, cantidad_boleto, event_id) => {
    console.log(precio_boleto, cantidad_boleto, event_id)
    const { data } = await Axios.post(`${globalConfig.url}/create-payment-intent`,
      { precio_boleto, cantidad_boleto, event_id }
    )
    return data
  },
  updatePaymentIntent: async (PaymentIntentId, reserva) => {
    const { data } = await Axios.put(`${globalConfig.url}/api/reservas/update/${PaymentIntentId}`,
      { reserva }
    )
    return data
  },
  createReservation: async (reservation) => {
    const { data } = await Axios.post(`${globalConfig.url}/api/reservas/new`, reservation)
    return data
  },
  getReservationQrByIdEventIdUser: async (id_evento) => {
    const { data } = await Axios.get(`${globalConfig.url}/api/eventos/${id_evento}/qr`)
    return data
  },
  getAllReservationsById: async () => {
    const { data } = await Axios.get(`${globalConfig.url}/api/usuarios/reservaciones`)
    return data
  },

  getTicketsReservation: async (id_evento) => {
    const { data } = await Axios.get(`${globalConfig.url}/api/usuarios/reservaciones/${id_evento}`)
    return data
  }
}
